// extracted by mini-css-extract-plugin
export default {"anchovy":"#c8c8c8","blueberry":"#312783","colorGreenText":"#158252","colorRedText":"#c82b49","desktop":"1440px","liquorice":"#242424","mobile":"834px","tablet":"835px"};